var Component = require("!../../../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../vue-loader/lib/selector?type=script&index=0!./tree.vue"),
  /* template */
  require("!!../../../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-79ac6d92\"}!../../../../../../vue-loader/lib/selector?type=template&index=0!./tree.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/element-ui/packages/tree/src/tree.vue
// module id = 1989
// module chunks = 228